module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid1_800x721.7dd9142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid1_800x721.jpg
// module id = X5Tt
// module chunks = 0